import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";

import DateField from "../../components/field/DateField/DateField";
import AutocompleteField from "../../components/field/AutocompleteField";
import { convertFlatListFromBackendToTranslatedOptionObject } from "../../helpers/methods";

export default function LeadChartFilterForm(props) {
  const { t } = useTranslation();


  const getFormContent = () => (
    <>
      {props.showInvestmentFilter && (
        <Grid item xs={12} md={props.isVerticalForm ? 12 : 1.75}>
          <AutocompleteField
            name="investment"
            value={props.formValue.investment}
            multiple={true}
            isObjectOption={true}
            options={props.filteringData?.investment}
            optionLabelKey={"investment_name_sales"}
            label={t("leads.table.investment")}
            onChange={props.onChangeAutocompleteFieldWithObjectOptions}
            limitTags={props.isVerticalForm ? undefined : 0}
          />
        </Grid>
      )}
      {props.showLeadSourceFilter && (
        <Grid item xs={12} md={props.isVerticalForm ? 12 : 1.75}>
          <AutocompleteField
            name="lead_source"
            value={props.formValue.lead_source}
            multiple={true}
            isObjectOption={true}
            options={props.filteringData?.lead_source}
            optionLabelKey={"channel_name"}
            label={t("leads.table.lead_source")}
            onChange={props.onChangeAutocompleteFieldWithObjectOptions}
            limitTags={props.isVerticalForm ? undefined : 0}
          />
        </Grid>
      )}
      {props.showChannelHigherNameFilter && (
        <Grid item xs={12} md={props.isVerticalForm ? 12 : 2}>
          <AutocompleteField
            name="channel_higher_name"
            value={props.formValue.channel_higher_name}
            multiple={true}
            isObjectOption={false}
            options={props.filteringData?.channel_higher_name}
            label={t("leads.table.channel_higher_name")}
            onChange={props.onChange}
            limitTags={props.isVerticalForm ? undefined : 0}
          />
        </Grid>
      )}
    {props.showChannelTypeFilter && (
        <Grid item xs={12} md={props.isVerticalForm ? 12 : 2}>
          <AutocompleteField
            name="channel_type"
            value={props.formValue.channel_type}
            multiple={true}
            isObjectOption={true}
            options={convertFlatListFromBackendToTranslatedOptionObject(
                        props.filteringData?.channel_type,
                        "id",
                        "name",
                        "channels.types",
            )}
            label={t("leads.table.channel_type")}
            onChange={props.onChangeAutocompleteFieldWithObjectOptions}
            limitTags={props.isVerticalForm ? undefined : 0}
          />
        </Grid>
      )}
      {props.showDateTimeRangeFilter && (
        <Grid
          item
          xs={12}
          md={props.isVerticalForm ? 12 : 3}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <DateField
            name={"lead_created_from"}
            label={t("leads.table.lead_created_from")}
            value={props.formValue.lead_created_from}
            onChange={props.onChangeDateConvertedToDateTimeWithZeroHourOfDate}
            showClearIcon={true}
            maxDate={
              props.formValue.lead_created_to
                ? props.formValue.lead_created_to
                : undefined
            }
          />
          <div style={{ marginInline: "5px" }}>{"-"}</div>
          <DateField
            name={"lead_created_to"}
            label={t("leads.table.lead_created_from")}
            value={props.formValue.lead_created_to}
            onChange={props.onChangeDateConvertedToDateTimeWithEndHourOfDate}
            showClearIcon={true}
            minDate={
              props.formValue.lead_created_to
                ? props.formValue.lead_created_to
                : undefined
            }
          />
        </Grid>
      )}
      </>
  );

  if (props.onlyFormContent) return getFormContent();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      rowSpacing={1}
    >
      {getFormContent()}
    </Grid>
  );
}

LeadChartFilterForm.propTypes = {
  formValue: PropTypes.object,
  filteringData: PropTypes.object,
  setFormValue: PropTypes.func,
  onChange: PropTypes.func,
  onChangeDateConvertedToDateTimeWithEndHourOfDate: PropTypes.func,
  onChangeDateConvertedToDateTimeWithZeroHourOfDate: PropTypes.func,
  onChangeAutocompleteFieldWithObjectOptions: PropTypes.func,
  isVerticalForm: PropTypes.bool,
  onlyFormContent: PropTypes.bool,
  showDateTimeRangeFilter: PropTypes.bool,
  showChannelHigherNameFilter: PropTypes.bool,
  showInvestmentFilter: PropTypes.bool,
  showLeadSourceFilter: PropTypes.bool,
  showChannelTypeFilter: PropTypes.bool
};

LeadChartFilterForm.defaultProps = {
  isVerticalForm: false,
  onlyFormContent: true,
  showDateTimeRangeFilter: true,
  showChannelHigherNameFilter: true,
  showInvestmentFilter: true,
  showLeadSourceFilter: true,
  showChannelTypeFilter: true
};
